/**
 * The access token, held in a module-scoped variable.
 *
 * Deliberately not `localStorage` or `sessionStorage`. Anything written there
 * is readable by any script on the origin, so a single injected dependency or
 * XSS hole turns into a stolen token that keeps working until it expires. A
 * closure variable dies with the tab, and the refresh cookie — which the page
 * cannot read at all — is what survives a reload instead.
 *
 * The consequence is that a refresh happens on every page load. That is the
 * intended trade: one extra request against a class of theft.
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = null;
}
